export const postHeaders = {
  "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
};
export const apiPaths = {
  geoFile: `/api/entries/download/geo/`,
};
